var cov_1c04nn6zf5 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tree/Node.tsx",
      hash = "960e53c7ccfa03861bf89c779374060d6d1e03db",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tree/Node.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 21
        },
        end: {
          line: 11,
          column: 50
        }
      },
      "1": {
        start: {
          line: 12,
          column: 0
        },
        end: {
          line: 12,
          column: 48
        }
      },
      "2": {
        start: {
          line: 13,
          column: 26
        },
        end: {
          line: 13,
          column: 55
        }
      },
      "3": {
        start: {
          line: 14,
          column: 0
        },
        end: {
          line: 14,
          column: 43
        }
      },
      "4": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "5": {
        start: {
          line: 24,
          column: 17
        },
        end: {
          line: 24,
          column: 22
        }
      },
      "6": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 16
        }
      },
      "7": {
        start: {
          line: 40,
          column: 33
        },
        end: {
          line: 40,
          column: 65
        }
      },
      "8": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 54
        }
      },
      "9": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 50
        }
      },
      "10": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 52
        }
      },
      "11": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 58
        }
      },
      "12": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 56
        }
      },
      "13": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 54
        }
      },
      "14": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 50
        }
      },
      "15": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 40
        }
      },
      "16": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 62
        }
      },
      "17": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 32
        }
      },
      "18": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 40
        }
      },
      "19": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 31
        }
      },
      "20": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 66
        }
      },
      "21": {
        start: {
          line: 66,
          column: 35
        },
        end: {
          line: 66,
          column: 66
        }
      },
      "22": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 21
        }
      },
      "23": {
        start: {
          line: 74,
          column: 42
        },
        end: {
          line: 74,
          column: 52
        }
      },
      "24": {
        start: {
          line: 75,
          column: 25
        },
        end: {
          line: 75,
          column: 35
        }
      },
      "25": {
        start: {
          line: 76,
          column: 21
        },
        end: {
          line: 76,
          column: 65
        }
      },
      "26": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 77,
          column: 53
        }
      },
      "27": {
        start: {
          line: 77,
          column: 41
        },
        end: {
          line: 77,
          column: 53
        }
      },
      "28": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 78,
          column: 65
        }
      },
      "29": {
        start: {
          line: 78,
          column: 54
        },
        end: {
          line: 78,
          column: 65
        }
      },
      "30": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 80,
          column: 43
        }
      },
      "31": {
        start: {
          line: 80,
          column: 31
        },
        end: {
          line: 80,
          column: 43
        }
      },
      "32": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 41
        }
      },
      "33": {
        start: {
          line: 81,
          column: 29
        },
        end: {
          line: 81,
          column: 41
        }
      },
      "34": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 15
        }
      },
      "35": {
        start: {
          line: 87,
          column: 29
        },
        end: {
          line: 87,
          column: 39
        }
      },
      "36": {
        start: {
          line: 89,
          column: 21
        },
        end: {
          line: 89,
          column: 41
        }
      },
      "37": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 31
        }
      },
      "38": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 40
        }
      },
      "39": {
        start: {
          line: 91,
          column: 18
        },
        end: {
          line: 91,
          column: 40
        }
      },
      "40": {
        start: {
          line: 95,
          column: 56
        },
        end: {
          line: 95,
          column: 66
        }
      },
      "41": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 26
        }
      },
      "42": {
        start: {
          line: 96,
          column: 20
        },
        end: {
          line: 96,
          column: 26
        }
      },
      "43": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 97,
          column: 21
        }
      },
      "44": {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 99,
          column: 49
        }
      },
      "45": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 100,
          column: 69
        }
      },
      "46": {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 101,
          column: 35
        }
      },
      "47": {
        start: {
          line: 102,
          column: 20
        },
        end: {
          line: 102,
          column: 68
        }
      },
      "48": {
        start: {
          line: 104,
          column: 22
        },
        end: {
          line: 104,
          column: 107
        }
      },
      "49": {
        start: {
          line: 105,
          column: 17
        },
        end: {
          line: 105,
          column: 50
        }
      },
      "50": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 106,
          column: 64
        }
      },
      "51": {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 107,
          column: 45
        }
      },
      "52": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 108,
          column: 46
        }
      },
      "53": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 109,
          column: 40
        }
      },
      "54": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 110,
          column: 41
        }
      },
      "55": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 111,
          column: 50
        }
      },
      "56": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 112,
          column: 44
        }
      },
      "57": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 67
        }
      },
      "58": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 120,
          column: 5
        }
      },
      "59": {
        start: {
          line: 116,
          column: 6
        },
        end: {
          line: 119,
          column: 8
        }
      },
      "60": {
        start: {
          line: 117,
          column: 25
        },
        end: {
          line: 117,
          column: 57
        }
      },
      "61": {
        start: {
          line: 118,
          column: 9
        },
        end: {
          line: 118,
          column: 82
        }
      },
      "62": {
        start: {
          line: 122,
          column: 4
        },
        end: {
          line: 122,
          column: 104
        }
      },
      "63": {
        start: {
          line: 124,
          column: 4
        },
        end: {
          line: 126,
          column: 9
        }
      },
      "64": {
        start: {
          line: 125,
          column: 6
        },
        end: {
          line: 125,
          column: 41
        }
      },
      "65": {
        start: {
          line: 130,
          column: 4
        },
        end: {
          line: 130,
          column: 27
        }
      },
      "66": {
        start: {
          line: 130,
          column: 21
        },
        end: {
          line: 130,
          column: 27
        }
      },
      "67": {
        start: {
          line: 132,
          column: 52
        },
        end: {
          line: 132,
          column: 62
        }
      },
      "68": {
        start: {
          line: 133,
          column: 20
        },
        end: {
          line: 133,
          column: 35
        }
      },
      "69": {
        start: {
          line: 134,
          column: 20
        },
        end: {
          line: 134,
          column: 42
        }
      },
      "70": {
        start: {
          line: 135,
          column: 19
        },
        end: {
          line: 135,
          column: 47
        }
      },
      "71": {
        start: {
          line: 137,
          column: 4
        },
        end: {
          line: 137,
          column: 35
        }
      },
      "72": {
        start: {
          line: 137,
          column: 29
        },
        end: {
          line: 137,
          column: 35
        }
      },
      "73": {
        start: {
          line: 138,
          column: 27
        },
        end: {
          line: 138,
          column: 49
        }
      },
      "74": {
        start: {
          line: 139,
          column: 26
        },
        end: {
          line: 139,
          column: 47
        }
      },
      "75": {
        start: {
          line: 141,
          column: 4
        },
        end: {
          line: 141,
          column: 63
        }
      },
      "76": {
        start: {
          line: 141,
          column: 57
        },
        end: {
          line: 141,
          column: 63
        }
      },
      "77": {
        start: {
          line: 143,
          column: 4
        },
        end: {
          line: 143,
          column: 68
        }
      },
      "78": {
        start: {
          line: 143,
          column: 49
        },
        end: {
          line: 143,
          column: 68
        }
      },
      "79": {
        start: {
          line: 145,
          column: 18
        },
        end: {
          line: 145,
          column: 30
        }
      },
      "80": {
        start: {
          line: 146,
          column: 17
        },
        end: {
          line: 146,
          column: 46
        }
      },
      "81": {
        start: {
          line: 147,
          column: 25
        },
        end: {
          line: 147,
          column: 90
        }
      },
      "82": {
        start: {
          line: 148,
          column: 25
        },
        end: {
          line: 148,
          column: 53
        }
      },
      "83": {
        start: {
          line: 149,
          column: 25
        },
        end: {
          line: 149,
          column: 45
        }
      },
      "84": {
        start: {
          line: 151,
          column: 19
        },
        end: {
          line: 151,
          column: 35
        }
      },
      "85": {
        start: {
          line: 152,
          column: 4
        },
        end: {
          line: 152,
          column: 42
        }
      },
      "86": {
        start: {
          line: 153,
          column: 4
        },
        end: {
          line: 167,
          column: 5
        }
      },
      "87": {
        start: {
          line: 154,
          column: 6
        },
        end: {
          line: 154,
          column: 57
        }
      },
      "88": {
        start: {
          line: 155,
          column: 6
        },
        end: {
          line: 163,
          column: 7
        }
      },
      "89": {
        start: {
          line: 156,
          column: 8
        },
        end: {
          line: 162,
          column: 9
        }
      },
      "90": {
        start: {
          line: 157,
          column: 10
        },
        end: {
          line: 157,
          column: 23
        }
      },
      "91": {
        start: {
          line: 158,
          column: 10
        },
        end: {
          line: 158,
          column: 61
        }
      },
      "92": {
        start: {
          line: 160,
          column: 10
        },
        end: {
          line: 160,
          column: 23
        }
      },
      "93": {
        start: {
          line: 161,
          column: 10
        },
        end: {
          line: 161,
          column: 80
        }
      },
      "94": {
        start: {
          line: 165,
          column: 6
        },
        end: {
          line: 165,
          column: 19
        }
      },
      "95": {
        start: {
          line: 166,
          column: 6
        },
        end: {
          line: 166,
          column: 76
        }
      },
      "96": {
        start: {
          line: 168,
          column: 4
        },
        end: {
          line: 168,
          column: 36
        }
      },
      "97": {
        start: {
          line: 170,
          column: 4
        },
        end: {
          line: 170,
          column: 56
        }
      },
      "98": {
        start: {
          line: 174,
          column: 4
        },
        end: {
          line: 174,
          column: 35
        }
      },
      "99": {
        start: {
          line: 175,
          column: 4
        },
        end: {
          line: 175,
          column: 27
        }
      },
      "100": {
        start: {
          line: 175,
          column: 21
        },
        end: {
          line: 175,
          column: 27
        }
      },
      "101": {
        start: {
          line: 176,
          column: 4
        },
        end: {
          line: 176,
          column: 22
        }
      },
      "102": {
        start: {
          line: 177,
          column: 4
        },
        end: {
          line: 177,
          column: 40
        }
      },
      "103": {
        start: {
          line: 177,
          column: 34
        },
        end: {
          line: 177,
          column: 40
        }
      },
      "104": {
        start: {
          line: 179,
          column: 4
        },
        end: {
          line: 179,
          column: 106
        }
      },
      "105": {
        start: {
          line: 179,
          column: 53
        },
        end: {
          line: 179,
          column: 106
        }
      },
      "106": {
        start: {
          line: 180,
          column: 34
        },
        end: {
          line: 180,
          column: 44
        }
      },
      "107": {
        start: {
          line: 181,
          column: 21
        },
        end: {
          line: 181,
          column: 83
        }
      },
      "108": {
        start: {
          line: 182,
          column: 23
        },
        end: {
          line: 182,
          column: 32
        }
      },
      "109": {
        start: {
          line: 184,
          column: 4
        },
        end: {
          line: 184,
          column: 53
        }
      },
      "110": {
        start: {
          line: 185,
          column: 4
        },
        end: {
          line: 187,
          column: 5
        }
      },
      "111": {
        start: {
          line: 186,
          column: 6
        },
        end: {
          line: 186,
          column: 34
        }
      },
      "112": {
        start: {
          line: 191,
          column: 91
        },
        end: {
          line: 191,
          column: 101
        }
      },
      "113": {
        start: {
          line: 193,
          column: 21
        },
        end: {
          line: 193,
          column: 71
        }
      },
      "114": {
        start: {
          line: 194,
          column: 24
        },
        end: {
          line: 194,
          column: 55
        }
      },
      "115": {
        start: {
          line: 195,
          column: 35
        },
        end: {
          line: 195,
          column: 45
        }
      },
      "116": {
        start: {
          line: 197,
          column: 22
        },
        end: {
          line: 206,
          column: 5
        }
      },
      "117": {
        start: {
          line: 208,
          column: 22
        },
        end: {
          line: 208,
          column: 24
        }
      },
      "118": {
        start: {
          line: 209,
          column: 4
        },
        end: {
          line: 215,
          column: 5
        }
      },
      "119": {
        start: {
          line: 210,
          column: 6
        },
        end: {
          line: 214,
          column: 8
        }
      },
      "120": {
        start: {
          line: 218,
          column: 24
        },
        end: {
          line: 218,
          column: 28
        }
      },
      "121": {
        start: {
          line: 219,
          column: 4
        },
        end: {
          line: 223,
          column: 5
        }
      },
      "122": {
        start: {
          line: 220,
          column: 6
        },
        end: {
          line: 220,
          column: 31
        }
      },
      "123": {
        start: {
          line: 221,
          column: 11
        },
        end: {
          line: 223,
          column: 5
        }
      },
      "124": {
        start: {
          line: 222,
          column: 6
        },
        end: {
          line: 222,
          column: 37
        }
      },
      "125": {
        start: {
          line: 225,
          column: 4
        },
        end: {
          line: 243,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        loc: {
          start: {
            line: 37,
            column: 49
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 37
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        loc: {
          start: {
            line: 52,
            column: 28
          },
          end: {
            line: 54,
            column: 3
          }
        },
        line: 52
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 3
          }
        },
        loc: {
          start: {
            line: 56,
            column: 25
          },
          end: {
            line: 59,
            column: 3
          }
        },
        line: 56
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 61,
            column: 3
          }
        },
        loc: {
          start: {
            line: 61,
            column: 33
          },
          end: {
            line: 63,
            column: 3
          }
        },
        line: 61
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 65,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        },
        loc: {
          start: {
            line: 65,
            column: 47
          },
          end: {
            line: 67,
            column: 3
          }
        },
        line: 65
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 69,
            column: 2
          },
          end: {
            line: 69,
            column: 3
          }
        },
        loc: {
          start: {
            line: 69,
            column: 34
          },
          end: {
            line: 71,
            column: 3
          }
        },
        line: 69
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 73,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        },
        loc: {
          start: {
            line: 73,
            column: 11
          },
          end: {
            line: 84,
            column: 3
          }
        },
        line: 73
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 86,
            column: 2
          },
          end: {
            line: 86,
            column: 3
          }
        },
        loc: {
          start: {
            line: 86,
            column: 17
          },
          end: {
            line: 92,
            column: 3
          }
        },
        line: 86
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 94,
            column: 2
          },
          end: {
            line: 94,
            column: 3
          }
        },
        loc: {
          start: {
            line: 94,
            column: 42
          },
          end: {
            line: 127,
            column: 3
          }
        },
        line: 94
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 116,
            column: 42
          },
          end: {
            line: 116,
            column: 43
          }
        },
        loc: {
          start: {
            line: 116,
            column: 47
          },
          end: {
            line: 119,
            column: 7
          }
        },
        line: 116
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 124,
            column: 15
          },
          end: {
            line: 124,
            column: 16
          }
        },
        loc: {
          start: {
            line: 124,
            column: 21
          },
          end: {
            line: 126,
            column: 5
          }
        },
        line: 124
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 129,
            column: 2
          },
          end: {
            line: 129,
            column: 3
          }
        },
        loc: {
          start: {
            line: 129,
            column: 53
          },
          end: {
            line: 171,
            column: 3
          }
        },
        line: 129
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 173,
            column: 2
          },
          end: {
            line: 173,
            column: 3
          }
        },
        loc: {
          start: {
            line: 173,
            column: 18
          },
          end: {
            line: 188,
            column: 3
          }
        },
        line: 173
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 190,
            column: 2
          },
          end: {
            line: 190,
            column: 3
          }
        },
        loc: {
          start: {
            line: 190,
            column: 11
          },
          end: {
            line: 244,
            column: 3
          }
        },
        line: 190
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 66,
            column: 66
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 66,
            column: 66
          }
        }, {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 66,
            column: 66
          }
        }],
        line: 66
      },
      "1": {
        loc: {
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 77,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 77,
            column: 53
          }
        }, {
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 77,
            column: 53
          }
        }],
        line: 77
      },
      "2": {
        loc: {
          start: {
            line: 77,
            column: 8
          },
          end: {
            line: 77,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 77,
            column: 8
          },
          end: {
            line: 77,
            column: 16
          }
        }, {
          start: {
            line: 77,
            column: 20
          },
          end: {
            line: 77,
            column: 39
          }
        }],
        line: 77
      },
      "3": {
        loc: {
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 78,
            column: 65
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 78,
            column: 65
          }
        }, {
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 78,
            column: 65
          }
        }],
        line: 78
      },
      "4": {
        loc: {
          start: {
            line: 78,
            column: 8
          },
          end: {
            line: 78,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 78,
            column: 8
          },
          end: {
            line: 78,
            column: 31
          }
        }, {
          start: {
            line: 78,
            column: 35
          },
          end: {
            line: 78,
            column: 52
          }
        }],
        line: 78
      },
      "5": {
        loc: {
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 80,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 80,
            column: 43
          }
        }, {
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 80,
            column: 43
          }
        }],
        line: 80
      },
      "6": {
        loc: {
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 80,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 80,
            column: 16
          }
        }, {
          start: {
            line: 80,
            column: 20
          },
          end: {
            line: 80,
            column: 29
          }
        }],
        line: 80
      },
      "7": {
        loc: {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 41
          }
        }, {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 41
          }
        }],
        line: 81
      },
      "8": {
        loc: {
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 81,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 81,
            column: 14
          }
        }, {
          start: {
            line: 81,
            column: 18
          },
          end: {
            line: 81,
            column: 27
          }
        }],
        line: 81
      },
      "9": {
        loc: {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 91,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 91,
            column: 40
          }
        }, {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 91,
            column: 40
          }
        }],
        line: 91
      },
      "10": {
        loc: {
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 96,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 96,
            column: 26
          }
        }, {
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 96,
            column: 26
          }
        }],
        line: 96
      },
      "11": {
        loc: {
          start: {
            line: 104,
            column: 22
          },
          end: {
            line: 104,
            column: 107
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 104,
            column: 22
          },
          end: {
            line: 104,
            column: 29
          }
        }, {
          start: {
            line: 104,
            column: 34
          },
          end: {
            line: 104,
            column: 106
          }
        }],
        line: 104
      },
      "12": {
        loc: {
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 120,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 120,
            column: 5
          }
        }, {
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 120,
            column: 5
          }
        }],
        line: 115
      },
      "13": {
        loc: {
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 130,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 130,
            column: 27
          }
        }, {
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 130,
            column: 27
          }
        }],
        line: 130
      },
      "14": {
        loc: {
          start: {
            line: 137,
            column: 4
          },
          end: {
            line: 137,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 137,
            column: 4
          },
          end: {
            line: 137,
            column: 35
          }
        }, {
          start: {
            line: 137,
            column: 4
          },
          end: {
            line: 137,
            column: 35
          }
        }],
        line: 137
      },
      "15": {
        loc: {
          start: {
            line: 137,
            column: 8
          },
          end: {
            line: 137,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 137,
            column: 8
          },
          end: {
            line: 137,
            column: 16
          }
        }, {
          start: {
            line: 137,
            column: 20
          },
          end: {
            line: 137,
            column: 27
          }
        }],
        line: 137
      },
      "16": {
        loc: {
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 141,
            column: 63
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 141,
            column: 63
          }
        }, {
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 141,
            column: 63
          }
        }],
        line: 141
      },
      "17": {
        loc: {
          start: {
            line: 141,
            column: 8
          },
          end: {
            line: 141,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 141,
            column: 8
          },
          end: {
            line: 141,
            column: 19
          }
        }, {
          start: {
            line: 141,
            column: 23
          },
          end: {
            line: 141,
            column: 55
          }
        }],
        line: 141
      },
      "18": {
        loc: {
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 143,
            column: 68
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 143,
            column: 68
          }
        }, {
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 143,
            column: 68
          }
        }],
        line: 143
      },
      "19": {
        loc: {
          start: {
            line: 143,
            column: 8
          },
          end: {
            line: 143,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 143,
            column: 8
          },
          end: {
            line: 143,
            column: 23
          }
        }, {
          start: {
            line: 143,
            column: 27
          },
          end: {
            line: 143,
            column: 47
          }
        }],
        line: 143
      },
      "20": {
        loc: {
          start: {
            line: 147,
            column: 25
          },
          end: {
            line: 147,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 147,
            column: 25
          },
          end: {
            line: 147,
            column: 84
          }
        }, {
          start: {
            line: 147,
            column: 88
          },
          end: {
            line: 147,
            column: 90
          }
        }],
        line: 147
      },
      "21": {
        loc: {
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 167,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 167,
            column: 5
          }
        }, {
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 167,
            column: 5
          }
        }],
        line: 153
      },
      "22": {
        loc: {
          start: {
            line: 155,
            column: 6
          },
          end: {
            line: 163,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 155,
            column: 6
          },
          end: {
            line: 163,
            column: 7
          }
        }, {
          start: {
            line: 155,
            column: 6
          },
          end: {
            line: 163,
            column: 7
          }
        }],
        line: 155
      },
      "23": {
        loc: {
          start: {
            line: 156,
            column: 8
          },
          end: {
            line: 162,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 156,
            column: 8
          },
          end: {
            line: 162,
            column: 9
          }
        }, {
          start: {
            line: 156,
            column: 8
          },
          end: {
            line: 162,
            column: 9
          }
        }],
        line: 156
      },
      "24": {
        loc: {
          start: {
            line: 175,
            column: 4
          },
          end: {
            line: 175,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 175,
            column: 4
          },
          end: {
            line: 175,
            column: 27
          }
        }, {
          start: {
            line: 175,
            column: 4
          },
          end: {
            line: 175,
            column: 27
          }
        }],
        line: 175
      },
      "25": {
        loc: {
          start: {
            line: 177,
            column: 4
          },
          end: {
            line: 177,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 177,
            column: 4
          },
          end: {
            line: 177,
            column: 40
          }
        }, {
          start: {
            line: 177,
            column: 4
          },
          end: {
            line: 177,
            column: 40
          }
        }],
        line: 177
      },
      "26": {
        loc: {
          start: {
            line: 179,
            column: 4
          },
          end: {
            line: 179,
            column: 106
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 179,
            column: 4
          },
          end: {
            line: 179,
            column: 106
          }
        }, {
          start: {
            line: 179,
            column: 4
          },
          end: {
            line: 179,
            column: 106
          }
        }],
        line: 179
      },
      "27": {
        loc: {
          start: {
            line: 179,
            column: 8
          },
          end: {
            line: 179,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 179,
            column: 8
          },
          end: {
            line: 179,
            column: 22
          }
        }, {
          start: {
            line: 179,
            column: 26
          },
          end: {
            line: 179,
            column: 51
          }
        }],
        line: 179
      },
      "28": {
        loc: {
          start: {
            line: 181,
            column: 30
          },
          end: {
            line: 181,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 181,
            column: 30
          },
          end: {
            line: 181,
            column: 72
          }
        }, {
          start: {
            line: 181,
            column: 76
          },
          end: {
            line: 181,
            column: 78
          }
        }],
        line: 181
      },
      "29": {
        loc: {
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 187,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 187,
            column: 5
          }
        }, {
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 187,
            column: 5
          }
        }],
        line: 185
      },
      "30": {
        loc: {
          start: {
            line: 185,
            column: 8
          },
          end: {
            line: 185,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 185,
            column: 8
          },
          end: {
            line: 185,
            column: 14
          }
        }, {
          start: {
            line: 185,
            column: 19
          },
          end: {
            line: 185,
            column: 32
          }
        }, {
          start: {
            line: 185,
            column: 36
          },
          end: {
            line: 185,
            column: 54
          }
        }],
        line: 185
      },
      "31": {
        loc: {
          start: {
            line: 194,
            column: 24
          },
          end: {
            line: 194,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 194,
            column: 24
          },
          end: {
            line: 194,
            column: 32
          }
        }, {
          start: {
            line: 194,
            column: 36
          },
          end: {
            line: 194,
            column: 55
          }
        }],
        line: 194
      },
      "32": {
        loc: {
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 215,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 215,
            column: 5
          }
        }, {
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 215,
            column: 5
          }
        }],
        line: 209
      },
      "33": {
        loc: {
          start: {
            line: 219,
            column: 4
          },
          end: {
            line: 223,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 219,
            column: 4
          },
          end: {
            line: 223,
            column: 5
          }
        }, {
          start: {
            line: 219,
            column: 4
          },
          end: {
            line: 223,
            column: 5
          }
        }],
        line: 219
      },
      "34": {
        loc: {
          start: {
            line: 221,
            column: 11
          },
          end: {
            line: 223,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 221,
            column: 11
          },
          end: {
            line: 223,
            column: 5
          }
        }, {
          start: {
            line: 221,
            column: 11
          },
          end: {
            line: 223,
            column: 5
          }
        }],
        line: 221
      },
      "35": {
        loc: {
          start: {
            line: 229,
            column: 68
          },
          end: {
            line: 229,
            column: 100
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 229,
            column: 68
          },
          end: {
            line: 229,
            column: 81
          }
        }, {
          start: {
            line: 229,
            column: 85
          },
          end: {
            line: 229,
            column: 100
          }
        }],
        line: 229
      },
      "36": {
        loc: {
          start: {
            line: 241,
            column: 9
          },
          end: {
            line: 241,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 241,
            column: 9
          },
          end: {
            line: 241,
            column: 20
          }
        }, {
          start: {
            line: 241,
            column: 24
          },
          end: {
            line: 241,
            column: 63
          }
        }],
        line: 241
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Tree/Node.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { createElement } from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import { isFunc, isString } from '../utils/is';
import { treeClass } from './styles';
import Content from './Content';
import { getDirectionClass } from '../utils/classname';
var placeElement = (cov_1c04nn6zf5.s[0]++, document.createElement('div'));
cov_1c04nn6zf5.s[1]++;
placeElement.className = treeClass('drag-place');
var innerPlaceElement = (cov_1c04nn6zf5.s[2]++, document.createElement('div'));
cov_1c04nn6zf5.s[3]++;
placeElement.appendChild(innerPlaceElement);
var placeInfo = (cov_1c04nn6zf5.s[4]++, {
  start: '',
  target: ''
});
var isDragging = (cov_1c04nn6zf5.s[5]++, false);

var Node =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Node, _PureComponent);

  var _super = _createSuper2(Node);

  function Node(props) {
    var _this;

    _classCallCheck(this, Node);

    cov_1c04nn6zf5.f[0]++;
    cov_1c04nn6zf5.s[6]++;
    _this = _super.call(this, props);
    _this.element = void 0;
    _this.dragImage = void 0;

    var _ref = (cov_1c04nn6zf5.s[7]++, props.getNodeInitState(props.id)),
        active = _ref.active,
        expanded = _ref.expanded;

    cov_1c04nn6zf5.s[8]++;
    _this.state = {
      active: active,
      expanded: expanded,
      fetching: false
    };
    cov_1c04nn6zf5.s[9]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    cov_1c04nn6zf5.s[10]++;
    _this.handleToggle = _this.handleToggle.bind(_assertThisInitialized(_this));
    cov_1c04nn6zf5.s[11]++;
    _this.handleDragStart = _this.handleDragStart.bind(_assertThisInitialized(_this));
    cov_1c04nn6zf5.s[12]++;
    _this.handleDragOver = _this.handleDragOver.bind(_assertThisInitialized(_this));
    cov_1c04nn6zf5.s[13]++;
    _this.handleDragEnd = _this.handleDragEnd.bind(_assertThisInitialized(_this));
    cov_1c04nn6zf5.s[14]++;
    _this.setFetching = _this.setFetching.bind(_assertThisInitialized(_this));
    cov_1c04nn6zf5.s[15]++;
    _this.isLeaf = _this.isLeaf.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Node, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_1c04nn6zf5.f[1]++;
      cov_1c04nn6zf5.s[16]++;
      this.props.bindNode(this.props.id, this.update.bind(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_1c04nn6zf5.f[2]++;
      cov_1c04nn6zf5.s[17]++;

      _get(_getPrototypeOf(Node.prototype), "componentWillUnmount", this).call(this);

      cov_1c04nn6zf5.s[18]++;
      this.props.unbindNode(this.props.id);
    }
  }, {
    key: "setFetching",
    value: function setFetching(fetching) {
      cov_1c04nn6zf5.f[3]++;
      cov_1c04nn6zf5.s[19]++;
      this.setState({
        fetching: fetching
      });
    }
  }, {
    key: "update",
    value: function update(key, value) {
      cov_1c04nn6zf5.f[4]++;
      cov_1c04nn6zf5.s[20]++;

      if (this.state[key] !== value) {
        cov_1c04nn6zf5.b[0][0]++;
        cov_1c04nn6zf5.s[21]++;
        this.setState(_defineProperty({}, key, value));
      } else {
        cov_1c04nn6zf5.b[0][1]++;
      }
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      cov_1c04nn6zf5.f[5]++;
      cov_1c04nn6zf5.s[22]++;
      this.element = el;
    }
  }, {
    key: "isLeaf",
    value: function isLeaf() {
      cov_1c04nn6zf5.f[6]++;

      var _ref2 = (cov_1c04nn6zf5.s[23]++, this.props),
          childrenKey = _ref2.childrenKey,
          data = _ref2.data,
          loader = _ref2.loader;

      var _ref3 = (cov_1c04nn6zf5.s[24]++, this.state),
          fetching = _ref3.fetching;

      var children = (cov_1c04nn6zf5.s[25]++, data[childrenKey]);
      cov_1c04nn6zf5.s[26]++;

      if ((cov_1c04nn6zf5.b[2][0]++, children) && (cov_1c04nn6zf5.b[2][1]++, children.length > 0)) {
        cov_1c04nn6zf5.b[1][0]++;
        cov_1c04nn6zf5.s[27]++;
        return false;
      } else {
        cov_1c04nn6zf5.b[1][1]++;
      }

      cov_1c04nn6zf5.s[28]++;

      if ((cov_1c04nn6zf5.b[4][0]++, Array.isArray(children)) || (cov_1c04nn6zf5.b[4][1]++, children === null)) {
        cov_1c04nn6zf5.b[3][0]++;
        cov_1c04nn6zf5.s[29]++;
        return true;
      } else {
        cov_1c04nn6zf5.b[3][1]++;
      }

      cov_1c04nn6zf5.s[30]++;

      if ((cov_1c04nn6zf5.b[6][0]++, fetching) && (cov_1c04nn6zf5.b[6][1]++, !children)) {
        cov_1c04nn6zf5.b[5][0]++;
        cov_1c04nn6zf5.s[31]++;
        return false;
      } else {
        cov_1c04nn6zf5.b[5][1]++;
      }

      cov_1c04nn6zf5.s[32]++;

      if ((cov_1c04nn6zf5.b[8][0]++, loader) && (cov_1c04nn6zf5.b[8][1]++, !fetching)) {
        cov_1c04nn6zf5.b[7][0]++;
        cov_1c04nn6zf5.s[33]++;
        return false;
      } else {
        cov_1c04nn6zf5.b[7][1]++;
      }

      cov_1c04nn6zf5.s[34]++;
      return true;
    }
  }, {
    key: "handleToggle",
    value: function handleToggle() {
      cov_1c04nn6zf5.f[7]++;

      var _ref4 = (cov_1c04nn6zf5.s[35]++, this.props),
          id = _ref4.id,
          onToggle = _ref4.onToggle; // eslint-disable-next-line


      var expanded = (cov_1c04nn6zf5.s[36]++, !this.state.expanded);
      cov_1c04nn6zf5.s[37]++;
      this.setState({
        expanded: expanded
      });
      cov_1c04nn6zf5.s[38]++;

      if (onToggle) {
        cov_1c04nn6zf5.b[9][0]++;
        cov_1c04nn6zf5.s[39]++;
        onToggle(id, expanded);
      } else {
        cov_1c04nn6zf5.b[9][1]++;
      }
    }
  }, {
    key: "handleDragStart",
    value: function handleDragStart(event) {
      var _this2 = this;

      cov_1c04nn6zf5.f[8]++;

      var _ref5 = (cov_1c04nn6zf5.s[40]++, this.props),
          dragImageSelector = _ref5.dragImageSelector,
          dragImageStyle = _ref5.dragImageStyle,
          data = _ref5.data;

      cov_1c04nn6zf5.s[41]++;

      if (isDragging) {
        cov_1c04nn6zf5.b[10][0]++;
        cov_1c04nn6zf5.s[42]++;
        return;
      } else {
        cov_1c04nn6zf5.b[10][1]++;
      }

      cov_1c04nn6zf5.s[43]++;
      isDragging = true;
      cov_1c04nn6zf5.s[44]++;
      event.dataTransfer.effectAllowed = 'copyMove';
      cov_1c04nn6zf5.s[45]++;
      event.dataTransfer.setData('text/plain', this.props.id);
      cov_1c04nn6zf5.s[46]++;
      placeInfo.start = this.props.id;
      var element = (cov_1c04nn6zf5.s[47]++, document.querySelector(dragImageSelector(data)));
      var dragImage = (cov_1c04nn6zf5.s[48]++, (cov_1c04nn6zf5.b[11][0]++, element) || (cov_1c04nn6zf5.b[11][1]++, this.element.querySelector(".".concat(treeClass('content')))));
      var rect = (cov_1c04nn6zf5.s[49]++, dragImage.getBoundingClientRect());
      cov_1c04nn6zf5.s[50]++;
      this.dragImage = dragImage.cloneNode(true);
      cov_1c04nn6zf5.s[51]++;
      document.body.appendChild(this.dragImage);
      cov_1c04nn6zf5.s[52]++;
      this.dragImage.style.position = 'absolute';
      cov_1c04nn6zf5.s[53]++;
      this.dragImage.style.top = '-1000px';
      cov_1c04nn6zf5.s[54]++;
      this.dragImage.style.left = '-1000px';
      cov_1c04nn6zf5.s[55]++;
      this.dragImage.style.width = "".concat(rect.width, "px");
      cov_1c04nn6zf5.s[56]++;
      this.dragImage.style.background = '#fff';
      cov_1c04nn6zf5.s[57]++;
      this.dragImage.style.boxShadow = '0 0 5px 0 rgba(0, 0, 0, 0.1)';
      cov_1c04nn6zf5.s[58]++;

      if (dragImageStyle) {
        cov_1c04nn6zf5.b[12][0]++;
        cov_1c04nn6zf5.s[59]++;
        Object.keys(dragImageStyle).forEach(function (k) {
          cov_1c04nn6zf5.f[9]++;
          var styleKey = (cov_1c04nn6zf5.s[60]++, k);
          cov_1c04nn6zf5.s[61]++;
          _this2.dragImage.style[styleKey] = dragImageStyle[styleKey];
        });
      } else {
        cov_1c04nn6zf5.b[12][1]++;
      }

      cov_1c04nn6zf5.s[62]++;
      event.dataTransfer.setDragImage(this.dragImage, event.clientX - rect.left, event.clientY - rect.top);
      cov_1c04nn6zf5.s[63]++;
      setTimeout(function () {
        cov_1c04nn6zf5.f[10]++;
        cov_1c04nn6zf5.s[64]++;
        _this2.element.style.display = 'none';
      }, 0);
    }
  }, {
    key: "handleDragOver",
    value: function handleDragOver(e) {
      cov_1c04nn6zf5.f[11]++;
      cov_1c04nn6zf5.s[65]++;

      if (!isDragging) {
        cov_1c04nn6zf5.b[13][0]++;
        cov_1c04nn6zf5.s[66]++;
        return;
      } else {
        cov_1c04nn6zf5.b[13][1]++;
      }

      var _ref6 = (cov_1c04nn6zf5.s[67]++, this.props),
          dragHoverExpand = _ref6.dragHoverExpand,
          datum = _ref6.datum,
          dragSibling = _ref6.dragSibling;

      var startId = (cov_1c04nn6zf5.s[68]++, placeInfo.start);
      var current = (cov_1c04nn6zf5.s[69]++, datum.getPath(startId));
      var target = (cov_1c04nn6zf5.s[70]++, datum.getPath(this.props.id));
      cov_1c04nn6zf5.s[71]++;

      if ((cov_1c04nn6zf5.b[15][0]++, !current) || (cov_1c04nn6zf5.b[15][1]++, !target)) {
        cov_1c04nn6zf5.b[14][0]++;
        cov_1c04nn6zf5.s[72]++;
        return;
      } else {
        cov_1c04nn6zf5.b[14][1]++;
      }

      var currentPathStr = (cov_1c04nn6zf5.s[73]++, current.path.join('/'));
      var targetPathStr = (cov_1c04nn6zf5.s[74]++, target.path.join('/'));
      cov_1c04nn6zf5.s[75]++;

      if ((cov_1c04nn6zf5.b[17][0]++, dragSibling) && (cov_1c04nn6zf5.b[17][1]++, targetPathStr !== currentPathStr)) {
        cov_1c04nn6zf5.b[16][0]++;
        cov_1c04nn6zf5.s[76]++;
        return;
      } else {
        cov_1c04nn6zf5.b[16][1]++;
      }

      cov_1c04nn6zf5.s[77]++;

      if ((cov_1c04nn6zf5.b[19][0]++, dragHoverExpand) && (cov_1c04nn6zf5.b[19][1]++, !this.state.expanded)) {
        cov_1c04nn6zf5.b[18][0]++;
        cov_1c04nn6zf5.s[78]++;
        this.handleToggle();
      } else {
        cov_1c04nn6zf5.b[18][1]++;
      }

      var hover = (cov_1c04nn6zf5.s[79]++, this.element);
      var rect = (cov_1c04nn6zf5.s[80]++, hover.getBoundingClientRect());
      var clientHeight = (cov_1c04nn6zf5.s[81]++, (cov_1c04nn6zf5.b[20][0]++, e.target.getBoundingClientRect().height) || (cov_1c04nn6zf5.b[20][1]++, 20));
      var hoverMiddleY = (cov_1c04nn6zf5.s[82]++, (rect.bottom - rect.top) / 2);
      var hoverClientY = (cov_1c04nn6zf5.s[83]++, e.clientY - rect.top);
      var position = (cov_1c04nn6zf5.s[84]++, this.props.index);
      cov_1c04nn6zf5.s[85]++;
      innerPlaceElement.style.height = '0px';
      cov_1c04nn6zf5.s[86]++;

      if (hoverClientY < hoverMiddleY + clientHeight * 0.2) {
        cov_1c04nn6zf5.b[21][0]++;
        cov_1c04nn6zf5.s[87]++;
        hover.parentNode.insertBefore(placeElement, hover);
        cov_1c04nn6zf5.s[88]++;

        if (hoverClientY > clientHeight * 0.3) {
          cov_1c04nn6zf5.b[22][0]++;
          cov_1c04nn6zf5.s[89]++;

          if (!dragSibling) {
            cov_1c04nn6zf5.b[23][0]++;
            cov_1c04nn6zf5.s[90]++;
            position = -1;
            cov_1c04nn6zf5.s[91]++;
            innerPlaceElement.style.height = "".concat(rect.height, "px");
          } else {
            cov_1c04nn6zf5.b[23][1]++;
            cov_1c04nn6zf5.s[92]++;
            position += 1;
            cov_1c04nn6zf5.s[93]++;
            hover.parentNode.insertBefore(placeElement, hover.nextElementSibling);
          }
        } else {
          cov_1c04nn6zf5.b[22][1]++;
        }
      } else {
        cov_1c04nn6zf5.b[21][1]++;
        cov_1c04nn6zf5.s[94]++;
        position += 1;
        cov_1c04nn6zf5.s[95]++;
        hover.parentNode.insertBefore(placeElement, hover.nextElementSibling);
      }

      cov_1c04nn6zf5.s[96]++;
      placeInfo.target = this.props.id; // @ts-ignore

      cov_1c04nn6zf5.s[97]++;
      placeElement.setAttribute('data-position', position);
    }
  }, {
    key: "handleDragEnd",
    value: function handleDragEnd() {
      cov_1c04nn6zf5.f[12]++;
      cov_1c04nn6zf5.s[98]++;
      this.element.style.display = '';
      cov_1c04nn6zf5.s[99]++;

      if (!isDragging) {
        cov_1c04nn6zf5.b[24][0]++;
        cov_1c04nn6zf5.s[100]++;
        return;
      } else {
        cov_1c04nn6zf5.b[24][1]++;
      }

      cov_1c04nn6zf5.s[101]++;
      isDragging = false;
      cov_1c04nn6zf5.s[102]++;

      if (!placeElement.parentNode) {
        cov_1c04nn6zf5.b[25][0]++;
        cov_1c04nn6zf5.s[103]++;
        return;
      } else {
        cov_1c04nn6zf5.b[25][1]++;
      }

      cov_1c04nn6zf5.s[104]++;

      if ((cov_1c04nn6zf5.b[27][0]++, this.dragImage) && (cov_1c04nn6zf5.b[27][1]++, this.dragImage.parentNode)) {
        cov_1c04nn6zf5.b[26][0]++;
        cov_1c04nn6zf5.s[105]++;
        this.dragImage.parentNode.removeChild(this.dragImage);
      } else {
        cov_1c04nn6zf5.b[26][1]++;
      }

      var _ref7 = (cov_1c04nn6zf5.s[106]++, this.props),
          id = _ref7.id,
          index = _ref7.index,
          onDrop = _ref7.onDrop;

      var position = (cov_1c04nn6zf5.s[107]++, parseInt((cov_1c04nn6zf5.b[28][0]++, placeElement.getAttribute('data-position')) || (cov_1c04nn6zf5.b[28][1]++, ''), 10));

      var _ref8 = (cov_1c04nn6zf5.s[108]++, placeInfo),
          target = _ref8.target;

      cov_1c04nn6zf5.s[109]++;
      placeElement.parentNode.removeChild(placeElement);
      cov_1c04nn6zf5.s[110]++;

      if ((cov_1c04nn6zf5.b[30][0]++, onDrop) && ((cov_1c04nn6zf5.b[30][1]++, target !== id) || (cov_1c04nn6zf5.b[30][2]++, index !== position))) {
        cov_1c04nn6zf5.b[29][0]++;
        cov_1c04nn6zf5.s[111]++;
        onDrop(id, target, position);
      } else {
        cov_1c04nn6zf5.b[29][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_1c04nn6zf5.f[13]++;

      var _ref9 = (cov_1c04nn6zf5.s[112]++, this.props),
          data = _ref9.data,
          listComponent = _ref9.listComponent,
          onDrop = _ref9.onDrop,
          childrenClass = _ref9.childrenClass,
          leafClass = _ref9.leafClass,
          nodeClass = _ref9.nodeClass,
          other = _objectWithoutProperties(_ref9, ["data", "listComponent", "onDrop", "childrenClass", "leafClass", "nodeClass"]);

      var children = (cov_1c04nn6zf5.s[113]++, data[other.childrenKey]);
      var hasChildren = (cov_1c04nn6zf5.s[114]++, (cov_1c04nn6zf5.b[31][0]++, children) && (cov_1c04nn6zf5.b[31][1]++, children.length > 0));

      var _ref10 = (cov_1c04nn6zf5.s[115]++, this.state),
          expanded = _ref10.expanded,
          fetching = _ref10.fetching;

      var listProps = (cov_1c04nn6zf5.s[116]++, _objectSpread2(_objectSpread2({}, other), {}, {
        data: children,
        expanded: expanded,
        onDrop: onDrop,
        leafClass: leafClass,
        childrenClass: childrenClass,
        nodeClass: nodeClass,
        childrenClassName: childrenClass(data)
      }));
      var wrapProps = (cov_1c04nn6zf5.s[117]++, {});
      cov_1c04nn6zf5.s[118]++;

      if (onDrop) {
        cov_1c04nn6zf5.b[32][0]++;
        cov_1c04nn6zf5.s[119]++;
        Object.assign(wrapProps, {
          draggable: true,
          onDragStart: this.handleDragStart,
          onDragEnd: this.handleDragEnd
        });
      } else {
        cov_1c04nn6zf5.b[32][1]++;
      } // node className


      var nodeClassName = (cov_1c04nn6zf5.s[120]++, null);
      cov_1c04nn6zf5.s[121]++;

      if (isString(nodeClass)) {
        cov_1c04nn6zf5.b[33][0]++;
        cov_1c04nn6zf5.s[122]++;
        nodeClassName = nodeClass;
      } else {
        cov_1c04nn6zf5.b[33][1]++;
        cov_1c04nn6zf5.s[123]++;

        if (isFunc(nodeClass)) {
          cov_1c04nn6zf5.b[34][0]++;
          cov_1c04nn6zf5.s[124]++;
          nodeClassName = nodeClass(data);
        } else {
          cov_1c04nn6zf5.b[34][1]++;
        }
      }

      cov_1c04nn6zf5.s[125]++;
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({}, wrapProps, {
          ref: this.bindElement,
          className: classnames(treeClass(getDirectionClass('node')), (cov_1c04nn6zf5.b[35][0]++, this.isLeaf()) && (cov_1c04nn6zf5.b[35][1]++, leafClass(data)), nodeClassName),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 226,
            columnNumber: 7
          }
        }),
        /*#__PURE__*/
        React.createElement(Content, Object.assign({}, other, {
          active: this.state.active,
          data: data,
          expanded: expanded,
          onToggle: this.handleToggle,
          onDragOver: this.handleDragOver,
          setFetching: this.setFetching,
          fetching: fetching,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 231,
            columnNumber: 9
          }
        })), (cov_1c04nn6zf5.b[36][0]++, hasChildren) && (cov_1c04nn6zf5.b[36][1]++,
        /*#__PURE__*/
        createElement(listComponent, listProps)))
      );
    }
  }]);

  return Node;
}(PureComponent);

export default Node;